function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 19.84375 19.843751",
    id: "svg15374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-277.15624)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.20578705,
      strokeOpacity: 1
    },
    id: "rect4518-85-9-8-1-0-5-7-9",
    width: 19.84375,
    height: 19.84375,
    x: 0,
    y: 277.15625
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#c7c7c7",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.17834876,
      strokeOpacity: 1
    },
    id: "rect4518-8-4-5-38-2-5-2-1-7",
    width: 17.197918,
    height: 17.197918,
    x: 1.3229218,
    y: 278.47919
  }), /*#__PURE__*/React.createElement("g", {
    "aria-label": "?",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    id: "text4520",
    transform: "matrix(2.0859235,0,0,1.782724,80.7962,-171.20702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -31.884534,255.35967 q 0,1.28674 -1.038697,1.88619 -0.780314,0.44442 -0.847493,0.89917 -0.0155,0.11886 -0.02584,0.23771 -0.03617,0.10852 -0.186035,0.10852 -0.521932,0 -0.749309,0.062 -0.04651,0.0155 -0.07235,0.0155 -0.186035,0 -0.186035,-0.50643 0,-0.43925 0.506429,-1.08521 0.511597,-0.65112 0.511597,-1.09037 0,-0.66663 -0.707967,-0.66663 -0.449585,0 -1.167888,0.3514 -0.222208,0 -0.222208,-1.31775 0,-0.14469 0.0155,-0.21704 0.07235,-0.34623 0.862996,-0.53743 0.573608,-0.13953 1.105876,-0.13953 0.935343,0 1.550293,0.52193 0.651123,0.55294 0.651123,1.47795 z m -1.400432,4.44417 q 0,0.39791 -0.279052,0.6873 -0.273885,0.28939 -0.671794,0.28939 -0.397908,0 -0.676961,-0.28939 -0.273885,-0.28939 -0.273885,-0.6873 0,-0.39791 0.273885,-0.67696 0.279053,-0.28422 0.676961,-0.28422 0.397909,0 0.671794,0.28422 0.279052,0.27905 0.279052,0.67696 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.26458332
    },
    id: "path4522"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlaceholder);
export default __webpack_public_path__ + "static/media/icon-placeholder.cb97b6624e0df25f998b2f73885a7299.svg";
export { ForwardRef as ReactComponent };